import { AppShell } from '@mantine/core';
import { createExportReportBets } from 'features/export-report-bets';
import { createBetReportRegistry } from 'entities/bet';
import { betsReportPageModel } from '../model';
import cls from './bets-report-page.module.scss';

const BetReportRegistry = createBetReportRegistry(betsReportPageModel.betReportRegistryModel);

const ExportBetsReport = createExportReportBets(betsReportPageModel.exportReportBetsModel);

export const BetsReportPage = () => (
	<AppShell.Main className={cls.betsReportPage}>
		<BetReportRegistry topBarActionSlot={<ExportBetsReport />} />
	</AppShell.Main>
);
